/** PAGES PATHS */
const AUTH = 'auth';
const ROOT = '/';
const GENETIC_COUNSELING = 'genetic-counseling';

/** ROUTES PATHS */
export const PATHS = {
  AUTH_CALLBACK: 'login/callback',
  AUTH: `${AUTH}`,
  COMMUNITY_OUTREACH: 'community-outreach',
  DASHBOARD: 'dashboard',
  GENETIC_COUNSELING: {
    COMPLETED: `completed`,
    DECLINED: `declined`,
    PATIENT: `patient`,
    REFERRALS: `referrals`,
    ROOT: `${GENETIC_COUNSELING}`,
    UPCOMING: `upcoming`,
    NEW: `new`,
  },
  HRN_WITHDRAWAL: 'withdrawal',
  LOGIN: 'login',
  MY_ACCOUNT: 'my-account',
  ROOT: `${ROOT}`,
  STUDY_INSIGHTS: 'study-insights',
  STUDY_INSIGHTS_PAGES: {
    COLLECTION_AND_SEQUENCING: 'collection-and-sequencing',
    DELIVERY_AND_RESULTS: 'delivery-and-results',
    PARTICIPANT_RECRUITMENT: 'participant-recruitment',
    SAMPLE_TRACKING: 'sample-tracking',
    KIT_FAILURE_REASON: 'kit-failure-reason',
  },
  TEAMS_ADD_TEAM_MEMBER: '/teams/add-team-member',
  TEAMS: 'teams',
};
